import React from "react"

import {
  prefetchPartnersUsersListQuery,
  usePartnersUsersList,
} from "@boundless/bl-api-client/partners/services"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { RefreshCwIcon } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { InviteUserDialog } from "@/components/users/InviteUserDialog"
import { PartnerUserProvider } from "@/components/users/providers/UserProvider"
import { FallbackUserTable, UserTable } from "@/components/users/UserTable"
import { cn } from "@/lib/utils"

export const Route = createFileRoute("/_dashboard/partners/users")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["users.view_partneruser"])) {
      throw redirect({ to: "/" })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await prefetchPartnersUsersListQuery(queryClient)
  },
})

function RouteComponent() {
  const { refetch, isFetching } = usePartnersUsersList()
  return (
    <Card>
      <CardHeader className="flex flex-row justify-between">
        <CardTitle>Users</CardTitle>
        <Button
          className="h-8 min-w-8"
          onClick={() => refetch()}
          disabled={isFetching}
        >
          <RefreshCwIcon className={cn(isFetching && "animate-spin")} />
        </Button>
      </CardHeader>
      <PartnerUserProvider>
        <CardContent>
          <React.Suspense fallback={<FallbackUserTable />}>
            <UserTable />
          </React.Suspense>
        </CardContent>
        <CardFooter className="justify-right">
          <InviteUserDialog />
        </CardFooter>
      </PartnerUserProvider>
    </Card>
  )
}
